import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  return _openBlock(), _createBlock(_component_el_select, null, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, function (lang) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: lang.id,
          label: lang.name,
          value: lang.id
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  });
}